import { ERoutePaths } from "@gift/types";
import { Route } from "react-router-dom";
import { Page_Account } from "./Account";

export default [
    <Route path={ERoutePaths.ACCOUNT} element={<Page_Account />} />,
];
